import { render, staticRenderFns } from "./ShowSubcategory.vue?vue&type=template&id=6b113282"
import script from "./ShowSubcategory.vue?vue&type=script&lang=js"
export * from "./ShowSubcategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports